<template>
<div>
    <smallbutton toplabel="Add Reservation" @click="startUpdate()" v-if="isNew"/>
    <linkbutton toplabel="Update" @click="startUpdate()" v-if="!isNew"/>

    <!-- MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <form id="updateguestform" ref="updateguestform" @submit.prevent v-if="ticket!=null">
                <label class="titlelabel">{{ title }}</label>

                <div class="margin10">
                    <label>{{ seatingMessage }}</label>
                </div>
                
                <formentry inputid="guest name" label="Guest Name" isrequired='True' v-model="ticket.TakeOutGuestName" />
                <formentry inputid="guest count" label="Guest Count" isrequired='True' v-model="ticket.guestCount"  />
               
                <formentry inputid="phone number" label="Phone" inputtype="tel" isrequired="True" @input="formatPhoneRes" v-model="ticket.guestPhone"/> 

                <smallbutton  @click="save()" toplabel="Save" :disabled="inSave" buttonclass="button buttonsave"/>
                <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Cancel" buttonclass="button buttoncancel"/>
                <div>
                    <label class="responsemessage">{{responseMessage}}</label>
                </div>
            </form>
            
        </template>
      </actionmodal>
    </div>
</template>

<script>
import datamethods from '../../services/datamethods'
import format from '../../style/format'
import smallbutton from '../controls/button.vue'
import actionmodal from '../controls/actionmodal.vue'
import formentry from '../controls/entry.vue'
import linkbutton from '../controls/linkbutton.vue'
import pencilbutton from '../controls/pencilbutton.vue'
export default {
    name:'updatereservation',
    components:{
        smallbutton,
        actionmodal,
        formentry,
        linkbutton,
        pencilbutton
    },
    mixins:[datamethods,format],
    props:{
        reservationTicket:{
            type:Object,
        },
        isNew:{
            type:Boolean,
            default:false
        },
        seating:{
            type:Object,
            required:true
        },
        businessDayId:{
            type:Number,
            required:true
        },
        terminalId:{
            type:Number,
            required:true
        }
        
    },
    
    data(){
        return{
            responseMessage:'',
            ticket:null,
            originalGuestCount:0,
            inSave:false
            
        }
    },
    computed:{
           
            seatingMessage(){
                var msg = null
               if(this.seating==null){
                    msg="The date and seating selected is not available for reservations."
                }else{
                    msg="There are " + this.seating.seatsAvailable + " seats available"
                }
                return msg
            },
            title(){
                var msg = 'Add Reservation for '
                msg= msg + this.seating.name
                return msg
            }
            
        },
    methods:{
       formatPhoneRes(e) {
            console.log('formatPhone fired:', e)
            let value = ''

            if (typeof e === 'string') {
            value = e
            } else if (e && e.target) {
            value = e.target.value
            } else {
            return
            }

            let digits = value.toString().replace(/\D/g, '').slice(0, 10)

            let formatted = digits

            if (digits.length > 3) {
            formatted = `(${digits.slice(0, 3)}) ${digits.slice(3)}`
            }

            if (digits.length > 6) {
            formatted = `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
            }

            this.ticket.guestPhone = formatted
        },
        async startUpdate(){

            this.responseMessage = ''


            if(this.isNew){
                this.ticket={
                    id:0,
                    TakeOutGuestName:null,
                    guestCount:1,
                    guestPhone:null,
                    seatingId:this.seating.id,
                    startDateTime:this.seating.seatingDateTime,
                    businessDayId:this.businessDayId,
                    terminalId:this.terminalId

                }
                this.originalGuestCount=0
                
            }else{
            
                this.ticket=this.reservationTicket
                this.originalGuestCount=this.ticket.guestCount
                this.ticket.TakeOutGuestName=this.ticket.guestName
            }
            this.$refs.mymodal.openModal()
           

        },
     
        async save(){
            if(this.inSave){return}
            
            if(this.$refs.updateguestform.checkValidity()==false){
                this.responseMessage="Please fill in all of the required fields "
                return}

            if(this.isNew)    {
                if(this.ticket.guestCount> this.seating.seatsAvailable ){
                    this.responseMessage="Please enter a guest count less than or equal to " + this.seating.seatsAvailable
                    return
                }
            }
            
            this.ticket.guestPhone=this.$options.filters.cleanPhone(this.ticket.guestPhone)
            if(this.ticket.guestPhone.length!=10){
                console.log(this.ticket.guestPhone)
                this.responseMessage="Please enter a 10 digit phone number"
                    return
            }

            this.inSave=true

            let req = {
                ticket:this.ticket
            }
            var response 
            if(this.isNew){
                response=await this.callAPI(req,'addticket')
            }else{
                req.originalGuestCount=this.originalGuestCount
                response=await this.callAPI(req, 'ticket_savereservation')
            }
            if(response.Successful){
                this.inSave=false
                this.$emit('refresh')
                this.$refs.mymodal.closeModal()
          
            }else{
                this.inSave=false
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
        },
        
        leavePhone(){

            this.ticket.guestPhone=this.$options.filters.formatPhone(this.ticket.guestPhone);
            
            
        },
       
    }
}
</script>

<style>
.entryCheckLabel{
    margin:0px 0px 0px 5px;
    font-size:medium;
    text-align: left;  
    max-width: 420px;
}
.entryCheckLabelbold{
    margin:0px 0px 0px 5px;
    font-size:medium;
    text-align: left;  
    max-width: 420px;
    font-weight:bold;
}
</style>





























